/* eslint-disable unicorn/consistent-function-scoping */
import { t } from "@lingui/macro";
import { ResumeDto } from "@reactive-resume/dto";
import { ResumeData } from "@reactive-resume/schema";
import {
  Button,
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@reactive-resume/ui";
import dayjs from "dayjs";
import { useState } from "react";
import { LuLoaderCircle } from "react-icons/lu";

import useAjaxLanguageTranslation from "@/client/hooks/use-ajax-language-translation";
import { useToast } from "@/client/hooks/use-toast";
import { parseDataToResume } from "@/client/libs/parse-data-to-resume/index";
import { postToParent } from "@/client/post-to-parent-utils";
import { useResumeStore } from "@/client/stores/resume";

import { getSectionIcon } from "../../shared/section-icon";
import options from "./options";

export const SecTranslation = () => {
  const resume = useResumeStore((state) => state.resume);

  const [value, setValue] = useState<string | undefined>();

  const { loading, doAjax } = useAjaxLanguageTranslation();

  const [replaceLoading, setReplaceLoading] = useState(false);

  const [copyLoading, setCopyLoading] = useState(false);

  const { toast } = useToast();

  const action = async () => {
    if (!value) {
      return;
    }
    const res = await doAjax(JSON.stringify(resume.data), value);
    if (!res) {
      // toast({
      //   variant: "error",
      //   title: t`SecTranslationError`,
      // });
      return;
    }
    let resumeResult: ResumeData | null = null;
    try {
      const object = parseDataToResume(resume.data, JSON.parse(res));
      // resumeResult = resumeDataSchema.parse(object);
      resumeResult = object;
    } catch (error) {
      console.log(error);
    }
    if (!resumeResult) {
      toast({
        variant: "error",
        title: t`SecTranslationError`,
      });
      return;
    }
    const result: ResumeDto = {
      ...resume,
      data: resumeResult,
      updatedAt: dayjs().valueOf().toString(),
    };
    return result;
  };

  const onClickSubmitCopy = async () => {
    setCopyLoading(true);
    const result = await action();
    if (!result) {
      setCopyLoading(false);
      return;
    }
    result.createdAt = result.updatedAt;
    postToParent("CREATE_NEW_RESUME", result);
    setCopyLoading(false);
  };

  const onClickSubmitReplace = async () => {
    setReplaceLoading(true);
    const result = await action();
    if (!result) {
      setReplaceLoading(false);
      return;
    }
    useResumeStore.setState({ resume: result });
    postToParent("SAVE_TO_DB", result.data);
    setReplaceLoading(false);
  };

  return (
    <section id="sec-translation" className="grid gap-y-6">
      <header className="flex items-center justify-between">
        <div className="flex items-center gap-x-4">
          {getSectionIcon("sec-translation")}
          <h2 className="line-clamp-1 text-3xl font-bold">{t`SecTranslation`}</h2>
        </div>
      </header>

      <main className="grid gap-y-4">
        <div className="space-y-1.5">
          <Label>{t`SecTranslationSelectLabel`}</Label>
          <Select
            value={value}
            onValueChange={(value) => {
              setValue(value);
            }}
          >
            <SelectTrigger>
              <SelectValue placeholder={t`SecTranslationSelectValue`} />
            </SelectTrigger>
            <SelectContent>
              {options.map((item, index) => (
                <SelectItem key={index} value={item.value}>
                  {item.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <Button
            variant="outline"
            disabled={!value || loading}
            className="flex h-12 items-center justify-center overflow-hidden rounded border text-center text-sm ring-primary transition-colors hover:bg-secondary-accent focus:outline-none focus:ring-1 disabled:opacity-100"
            onClick={onClickSubmitCopy}
          >
            {copyLoading && <LuLoaderCircle className="mr-3 size-4 animate-spin" />}
            {t`SecTranslationSubmitCopy`}
          </Button>
          <Button
            variant="outline"
            disabled={!value || loading}
            className="flex h-12 items-center justify-center overflow-hidden rounded border text-center text-sm ring-primary transition-colors hover:bg-secondary-accent focus:outline-none focus:ring-1 disabled:opacity-100"
            onClick={onClickSubmitReplace}
          >
            {replaceLoading && <LuLoaderCircle className="mr-3 size-4 animate-spin" />}
            {t`SecTranslationSubmitReplace`}
          </Button>
        </div>
        {/* <div className="space-y-1.5">
          <div className="flex items-center gap-x-4">
            <Switch
              id="visibility"
              checked={isPublic}
              onCheckedChange={(checked) => {
                setValue("visibility", checked ? "public" : "private");
              }}
            />
            <div>
              <Label htmlFor="visibility" className="space-y-1">
                <p>{t`Public`}</p>
                <p className="text-xs opacity-60">
                  {t`Anyone with the link can view and download the resume.`}
                </p>
              </Label>
            </div>
          </div>
        </div>

        <AnimatePresence presenceAffectsLayout>
          {isPublic && (
            <motion.div
              layout
              className="space-y-1.5"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
            >
              <Label htmlFor="resume-url">{t`URL`}</Label>

              <div className="flex gap-x-1.5">
                <Input readOnly id="resume-url" value={url} className="flex-1" />

                <Tooltip content={t`Copy to Clipboard`}>
                  <Button size="icon" variant="ghost" onClick={onCopy}>
                    <CopySimple />
                  </Button>
                </Tooltip>
              </div>
            </motion.div>
          )}
        </AnimatePresence> */}
      </main>
    </section>
  );
};
